import { render } from "./blog_evento.vue?vue&type=template&id=d8a725b6&scoped=true"
import script from "./blog_evento.vue?vue&type=script&lang=js"
export * from "./blog_evento.vue?vue&type=script&lang=js"

import "./blog_evento.vue?vue&type=style&index=0&id=d8a725b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a725b6"]])

export default __exports__